<template>
    <vue-modal
        v-model="modal.isVisible"
        :header="true"
        :title="$t('optimize_image.components.auto_optimization')"
        :modalBodyClass="$prefixClass.modal + '-auto-setting'"
    >
        <a-form-model ref="form" :model="form">
            <a-form-model-item prop="image">
                <div class="m-b-8">
                    <a-switch v-model="form.optimize_image"
                    :prefixCls="$prefixClass.switch" />
                    <span for="image" class="m-l-8 semibold">{{ $t('optimize_image.components.optimize_images') }}</span>
                </div>
                <div class="m-l-50">
                    <i class="fas fa-alarm-clock primary-color m-r-8"></i>
                    <span v-html="$t('optimize_image.components.daily_scanning')"></span>
                </div>
            </a-form-model-item>

            <a-form-model-item prop="theme" class="m-t-16 p-t-16 border-top">
                <div class="m-b-8">
                    <a-switch v-model="form.optimize_theme"
                    :prefixCls="$prefixClass.switch"/>
                    <span for="theme" class="m-l-8 semibold">{{ $t('optimize_image.components.optimize_theme') }}</span>
                </div>
                <div class="m-l-50">
                    <p class="m-t-4 m-b-8">{{ $t('optimize_image.components.description_publish_theme') }}</p>
                    <i class="fas fa-alarm-clock primary-color m-r-8"></i>
                    <span v-html="$t('optimize_image.components.weekly_scanning')"></span>
                </div>
            </a-form-model-item>
        </a-form-model>

        <template slot="footer">
            <div :class="$prefixClass.row">
                <div :class="[$prefixClass.col + '-12', 'text-left']">
                    <p><span>{{$t('optimize_image.components.optimization_started')}}</span><span class="utc-time"> 12:00 AM (UTC-5)</span></p>
                </div>
                <div :class="$prefixClass.col + '-12'">
                    <a-button key="cancel" @click="handleCancel" v-html="$t('app.buttons.cancel')"></a-button>
                    <a-button key="submit" type="primary" :disabled="isDisabled" @click="saveAutoSettings()" v-html="$t('app.buttons.save')"></a-button>
                </div>
            </div>
        </template>
    </vue-modal>
</template>

<script>
export default {
    name: 'ModalOptimizationMethods',
    props:{
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        modal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', this.value)
            }
        }
    },

    data(){
        return{
            isModify: false,
            isDisabled: false,
            isSaved: false,
            form: {
                optimize_image: null,
                optimize_theme: null,
                publish_theme: null,
            }
        }
    },

    created() {
        this.formatForm(this.modal.formAutoSettings)
    },

    mounted () {
        let _this = this
        this.$nextTick(()=>{
            this.$watch('modal.formAutoSettings' , {
                handler : function(val){  
                    this.isModify = true
                    if (!this.isSaved) {
                        this.formatForm(val)
                    }
                },
                deep : true
            })
        })
        window.addEventListener('beforeunload', function (event) {
            if(_this.isModify){
                event.returnValue = true
            }
        }, false)
    },

    methods:{
        handleCancel() {
            this.modal.isVisible = false;
            this.formatForm(this.modal.formAutoSettings);
        },

        saveAutoSettings() {
            this.$emit('save-auto-setting', this.form);
            this.isSaved = true;
            this.modal.isVisible = false;
        },

        formatForm(val) {
            this.form.optimize_image = val.optimize_image == 1
            this.form.optimize_theme = val.optimize_theme == 1
            this.form.publish_theme = val.publish_theme == 1
        }
    }
}
</script>

<style lang="scss">
    .#{$modal} {
        &-auto-setting {
            max-height: 382px;
            .#{$modal}-footer {
                .a-row {
                    display: flex;
                    align-items: center;
                }
                font-size: 16px;
                color: #677c96;
                .utc-time {
                    font-weight: 600;
                    color: #162a41;
                }
            }
        }
    }
</style>